import { render, staticRenderFns } from "./list-elec-invoice.vue?vue&type=template&id=2aa15298&scoped=true&"
import script from "./list-elec-invoice.vue?vue&type=script&lang=js&"
export * from "./list-elec-invoice.vue?vue&type=script&lang=js&"
import style0 from "./list-elec-invoice.vue?vue&type=style&index=0&id=2aa15298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa15298",
  null
  
)

export default component.exports